import { Session } from "src/api/session";
import { DomainInfo } from "src/api/domainInfo";
import { LogVisitSource } from "src/constants";

export const LogVisitDetails = ({
    session,
    redirectUrl,
    domain,
    source,
}: {
    session: Session;
    redirectUrl: string;
    domain: DomainInfo;
    source: LogVisitSource;
}): void => {
    fetch(`${process.env.BACKEND_URL as string}/helsinki/api/v1/access-log`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-DOMAIN-NAME": domain.name,
            "X-API-KEY": process.env.HELSINKI_API_KEY ?? "",
        },
        body: JSON.stringify({
            data: {
                redirectUrl: redirectUrl,
                session: {
                    visitDetails: session?.visitDetails,
                },
                source,
            },
            domainId: domain.id,
            domainName: domain.name,
        }),
    })
        .then((response) => response.json())
        .then((data) => {
            // eslint-disable-next-line no-console
            console.log("Success:", data);
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error("Error:", error);
        });
};

export const logRumMetrics = ({
    rum,
    domainName,
    domainId,
    visitId,
    visitorId,
    trafficSourceNetwork,
}: {
    rum: Record<string, unknown>;
    domainName: string;
    domainId: number | null;
    visitId: string | null;
    visitorId: string | null;
    trafficSourceNetwork: string | null;
}): void => {
    fetch(`${process.env.BACKEND_URL as string}/helsinki/api/v1/access-log`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-DOMAIN-NAME": domainName,
            "X-API-KEY": process.env.HELSINKI_API_KEY ?? "",
        },
        body: JSON.stringify({
            data: {
                rum,
                source: "web-vitals",
                session: {
                    visitDetails: {
                        visitId,
                        visitorId,
                    },
                },
            },
            domainId,
            domainName,
            trafficSourceNetwork,
        }),
    })
        .then((response) => response.json())
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error("[logRumMetrics] Error:", error);
        });
};
